// Configuration for AWS Amplify
// Generated automatically from CloudFormation outputs

const config = {
  cognito: {
    userPoolId: 'ca-central-1_DGhY3k01Q',
    userPoolWebClientId: '5t16ne4rli0rrhq06sjiv6k3jo',
    identityPoolId: 'ca-central-1:fbb1c446-b5e2-486b-9710-31aeb97b0455',
    region: 'ca-central-1'
  },
  storage: {
    AWSS3: {
      bucket: 'challenge-prod-bd0939db-uploads',
      region: 'ca-central-1'
    }
  },
  api: {
    url: 'https://7mj972z7fc.execute-api.ca-central-1.amazonaws.com/prod/',
    region: 'ca-central-1'
  },
  uploads: {
    url: 'https://d1g9mj2rlbqbyl.cloudfront.net/'
  }
};

export default config;